import { ECoworkingSwitcherType } from './types';

export const switcherOptions = [
  {
    title: 'Отдельные офисы',
    value: ECoworkingSwitcherType.Office,
  },
  {
    title: 'Рабочие места',
    value: ECoworkingSwitcherType.Places,
  },
];
